'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _localSessionLogStore = {};

var localSessionLogger = function () {
    function localSessionLogger() {
        _classCallCheck(this, localSessionLogger);
    }

    /**
     * Set ELK Logging Configuration for local session logging associated with calling application
     * @param loggingConfiguration {object}
     * @description setter for application specific logging for ELK in COMMON-WEB
     */
    localSessionLogger.set = function set(loggingConfiguration) {
        if (!this.isValidConfiguration(loggingConfiguration)) throw "local session logger has not been initialized";

        _localSessionLogStore = loggingConfiguration;

        var elkStackLog = _localSessionLogStore.initialize('common-web:lib/elk/local.session.logger');
        elkStackLog.logger.info(elkStackLog.modelFactory.methodModelCommented('set', loggingConfiguration, 'session logger initialized'));
    };

    /**
     * Get ELK Logging Configuration for local session logging associated with calling application
     * @param scriptName {string}
     * @returns logConfiguration from application config/logging.config {object}
     */


    localSessionLogger.initialize = function initialize(scriptName) {
        if (!!!scriptName) throw 'log name required for instantiation';

        return this.isInitialized() && _localSessionLogStore.hasOwnProperty('initialize') ? _localSessionLogStore.initialize(scriptName) : {};
    };

    /**
     * Confirm ELK Logging Configuration for local session is initialized
     * @returns {boolean}
     */


    localSessionLogger.isInitialized = function isInitialized() {
        return this.isValidConfiguration(_localSessionLogStore);
    };

    /**
     * Confirm ELK Logging Configuration model for local session is valid model
     * @param loggingConfiguration
     * @returns {boolean}
     */


    localSessionLogger.isValidConfiguration = function isValidConfiguration(loggingConfiguration) {
        var propertyList = ['configuration', 'enabled', 'applicationName', 'logSessionIdentity', 'filterKeySets', 'filter', 'initialize'];
        var isValid = true;
        propertyList.forEach(function (property) {
            if (!loggingConfiguration.hasOwnProperty(property)) isValid = false;
        });

        return isValid;
    };

    return localSessionLogger;
}();

exports.default = localSessionLogger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/elk/local.session.logger.js
// module id = 325
// module chunks = 0